import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n";
import { whatsappUrl } from "@/utils";

export const WhatsAppFloat = () => {
  const { t } = useLanguage();
  return (
    <motion.a
      href={whatsappUrl(t.whatsapp.prefill)}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2.4, type: "spring", stiffness: 200, damping: 15 }}
      whileHover={{ scale: 1.12 }}
      className="pulse-ring fixed bottom-6 right-6 z-[80] w-16 h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl"
      aria-label={t.whatsapp.tooltip}
      title={t.whatsapp.tooltip}
      data-testid="whatsapp-float-button"
    >
      <MessageCircle className="w-7 h-7" fill="currentColor" />
    </motion.a>
  );
};
